import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import getUprateLogo from "../images/getUprateLogo-blank.png";
import { ReactComponent as DashboardLogo } from "../images/dashboard.svg";
import { ReactComponent as WalletLogo } from "../images/wallet.svg";
import { ReactComponent as BellLogo } from "../images/bell.svg";
import { ReactComponent as SettingsLogo } from "../images/settings.svg";
import userLogo from "../images/client1.png";
import { ReactComponent as LogoutIcon } from "../images/logout.svg";  // add logout icon import
import "./styles/Header.css";
import { API_URLS } from "../config";

const Header = ({ isScrolled }) => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const [branding, setBranding] = useState({
        logoUrl: userLogo,
        isLoading: true
    });
    
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('businessId');

    const [buttons, setButtons] = useState([
        {name: "dashboard", selected: false},
        {name: "settings", selected: false},
        {name: "payments", selected: false},
    ]);

    useEffect(() => {
        const currentPath = location.pathname;
        const updatedButtons = buttons.map(button => {
            let isSelected = false;
            if (button.name === 'dashboard' && (currentPath === '/' || currentPath === '/home')) {
                isSelected = true;
            } else if (button.name === 'settings' && currentPath === '/settings') {
                isSelected = true;
            } else if (button.name === 'payments' && currentPath === '/payments') {
                isSelected = true;
            }
            return { ...button, selected: isSelected };
        });
        setButtons(updatedButtons);
    }, [location.pathname]);
    
    useEffect(() => {
        if (!token || !id) {
            setBranding(prev => ({ ...prev, isLoading: false }));
            return;
        }

        setBranding(prev => ({ ...prev, isLoading: true }));

        fetch(API_URLS.branding(id), {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            console.log("Branding data fetched:", data);
            if (data && data.length > 0) {
                const fetchedBranding = data[0];
                setBranding({
                    logoUrl: fetchedBranding.logo_image_link || userLogo,
                    isLoading: false,
                });
            } else {
                setBranding({ logoUrl: userLogo, isLoading: false });
            }
        })
        .catch(error => {
            console.error("Error fetching branding:", error);
            setBranding({ logoUrl: userLogo, isLoading: false });
        });
    }, [id, token]);

    const handleButtonClick = (name) => {
        if(name === 'dashboard'){
            navigate('/');
        } else if(name === 'settings'){
            navigate('/settings');
        } else if (name === 'payments') {
            console.log("Payments clicked - implement navigation if required");
            const updatedButtons = buttons.map(button => ({
                ...button,
                selected: button.name === name
            }));
            setButtons(updatedButtons);
        }
    };

    // Add logout handler
    const handleLogout = () => {
        // call POST auth/logout endpoint to invalidate the session
        fetch(API_URLS.logout, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            // clear session data
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('businessId');
            localStorage.removeItem('businessName');
            localStorage.removeItem('name');
            localStorage.removeItem('email');
            // notify App of auth change
            window.dispatchEvent(new Event('authChange'));
            // redirect
            navigate('/login', { replace: true });
            return response.json();
        })
        .then(data => {
            // clear again in case, then notify and navigate
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('businessId');
            localStorage.removeItem('businessName');
            localStorage.removeItem('name');
            localStorage.removeItem('email');
            window.dispatchEvent(new Event('authChange'));
            setTimeout(() => {
                navigate('/login', { replace: true });
            }, 1000);
        })
        .catch(error => {
            console.error("Error logging out:", error);
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('businessId');
            localStorage.removeItem('businessName');
            localStorage.removeItem('name');
            localStorage.removeItem('email');
            window.dispatchEvent(new Event('authChange'));
            navigate('/login', { replace: true });
        });
    };

    return (
        <header className={`header-dashboard ${isScrolled ? 'scrolled' : ''}`}>
            <div className="provider">    
                <div className="logo">
                    <img src={getUprateLogo} alt="getUprate Logo" />
                    <h3>
                        <span>get</span>
                        <span className="uprate">Uprate</span>
                    </h3>
                </div>
                <div className="menu">
                    <button className={`dashboard-button ${buttons.find(b => b.name === 'dashboard')?.selected ? 'selected' : ''}`} onClick={() => handleButtonClick('dashboard')}>
                        <DashboardLogo/>
                        <span className="button-text">Dashboard</span>
                    </button>
                    <button className={`settings-button ${buttons.find(b => b.name === 'settings')?.selected ? 'selected' : ''}`} onClick={() => handleButtonClick('settings')}>
                        <SettingsLogo/>
                        <span className="button-text">Settings</span>
                    </button>
                    {/*<button className={`payments-button ${buttons.find(b => b.name === 'payments')?.selected ? 'selected' : ''}`} onClick={() => handleButtonClick('payments')}>
                        <WalletLogo/>
                        <span className="button-text">Payments</span>
                    </button>*/}
                </div>
            </div>
            <div className="user">
                <button className="notifications-button">
                    <BellLogo/>
                </button>
                <button className="user-info-button">
                    <img src={branding.logoUrl} alt="User Logo" />
                </button>
                <button className="logout-button" onClick={handleLogout} title="Logout">
                    Logout
                    <LogoutIcon />
                </button>
            </div>
        </header>
    );
}

export default Header;